
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.185 13.113a4.884 4.884 0 00-3.448-3.448C34.696 8.85 22.5 8.85 22.5 8.85s-12.196 0-15.237.815c-1.678.449-3 1.77-3.448 3.448C3 16.154 3 22.5 3 22.5s0 6.346.815 9.387c.448 1.678 1.77 3 3.448 3.448 3.041.815 15.237.815 15.237.815s12.196 0 15.237-.815c1.678-.448 3-1.77 3.448-3.448C42 28.846 42 22.5 42 22.5s0-6.346-.815-9.387zM18.6 28.35v-11.7l10.132 5.85L18.6 28.35z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    